import React from 'react';

const ShowDomainName = () => {
  // Get the hostname (e.g., www.example.com)
  const hostname = window.location.hostname;

  // Function to extract main domain name
  const extractDomainName = (host) => {
    // Remove subdomains like 'www'
    const parts = host.split('.');

    // Handle domains like 'www.example.com' or 'example.com'
    if (parts.length >= 2) {
      return parts[parts.length - 2]; // "example"
    }
    if (host === 'mpiraafrica'){
       return "Mpira Africa"
    }else if (host ==='mpiraraha'){
       return "Mpira Raha"
    }
    return host;
  };

  const domainName = extractDomainName(hostname);

  return (
    <>
      {domainName}
    </>
  );
};

export default ShowDomainName;
